// @flow

import { Loading } from '@shopify/app-bridge/actions';
import { getSABAppInstance_Normal } from './app';

let SABLoadingInstance = null;

function createSABLoadingInstance() {
  SABLoadingInstance = Loading.create(getSABAppInstance_Normal());
}

export function startSABLoading() {
  if (!SABLoadingInstance) createSABLoadingInstance();
  SABLoadingInstance.dispatch(Loading.Action.START);
}

export function stopSABLoading() {
  if (!SABLoadingInstance) createSABLoadingInstance();
  SABLoadingInstance.dispatch(Loading.Action.STOP);
}
